import { createTheme } from '@mui/material/styles';

// Claude-inspired colors with white background and light blue sidebar
const ottiColors = {
  primary: {
    main: '#1a73e8', // Claude-like blue
    light: '#e3f2fd', // Very light blue for hover
    dark: '#1557b0',
  },
  secondary: {
    main: '#9aa0a6', // Claude-like gray
    light: '#bdc1c6',
    dark: '#80868b',
  },
  background: {
    default: '#F3F3F6', // Light gray background
    paper: '#ffffff',   // White paper for input boxes
    chat: '#F3F3F6',    // Light gray chat area
    sidebar: '#e3f2fd', // Light blue sidebar (not used now)
  },
  text: {
    primary: '#202124', // Claude-like dark text
    secondary: '#5f6368', // Claude-like secondary text
    disabled: '#9aa0a6',
    light: '#ffffff', // For sidebar text
  },
  divider: '#e8eaed', // Claude-like dividers
  success: {
    main: '#34a853',
    light: '#81c995',
    dark: '#137333',
  },
  error: {
    main: '#ea4335',
    light: '#ff7961',
    dark: '#c62828',
  },
  warning: {
    main: '#fbbc04',
    light: '#ffcc02',
    dark: '#f57c00',
  },
};

export const ottiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: ottiColors.primary,
    secondary: ottiColors.secondary,
    background: ottiColors.background,
    text: ottiColors.text,
    divider: ottiColors.divider,
    success: ottiColors.success,
    error: ottiColors.error,
    warning: ottiColors.warning,
  },
  typography: {
    // Placeholder fonts - will be updated with Ottimate brand fonts
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      letterSpacing: '0.01em',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.01em',
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: 1.4,
      letterSpacing: '0.02em',
    },
  },
  shape: {
    borderRadius: 12, // Claude-like rounded corners
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 500,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
        elevation1: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#F3F3F6',
          color: '#1e293b',
        },
      },
    },
  },
});

export default ottiTheme;